import * as React from 'react'
import { Helmet } from 'react-helmet'
import { WrappedLoginFormDashboard } from './LoginFormDashboard'
import { useState, useEffect } from 'react'
import { Form, Icon, Radio } from 'antd'
import { WrappedLoginFormPOS } from './LoginFormPOS'
import './login.scss'
import { animated, useTransition } from 'react-spring'
import { Logos } from '@/app/components/Images/Logos'
import { LoginWrapper } from './LoginWrapper'
import { BackgroundImages } from '@/app/components/Images/BackgroundImages'
import { resetFavicon, setPOSFavicon } from '@/app/utilities/favicon'

export const Login = () => {
  const [showDashboardLogin, setShowDashboardLogin] = useState(true)

  useEffect(() => {
    // Adding class for the page to allow of custom CSS
    document.body.classList.add('login-page')
  }, [])

  useEffect(() => {
    if (showDashboardLogin) {
      resetFavicon()
    } else {
      setPOSFavicon()
    }
  }, [showDashboardLogin])

  const transitions = useTransition(showDashboardLogin, null, {
    from: { position: 'absolute', opacity: 0 },
    enter: { position: 'relative', opacity: 1 },
    leave: { position: 'absolute', opacity: 0 },
  })

  return (
    <>
      <Helmet>
        <title>Login</title>
        <meta name='page-loaded' content='true' />
      </Helmet>

      {
        // Checking if chrome
        !window.hasOwnProperty('chrome') && !window.navigator.userAgent.match('CriOS') && (
          <div className='alert alert-warning text-center mb-0'>
            <div className='fa fa-exclamation-triangle mr-2'></div>
            We recommend you use{' '}
            <a href='https://www.google.com/chrome/' target='_blank' rel='noreferrer'>
              Google Chrome
            </a>{' '}
            for the best and most secure browsing experience
          </div>
        )
      }

      <LoginWrapper
        backgroundStyle={{
          background: `linear-gradient(0deg, rgba(38, 50, 56, 0.7), rgba(38, 50, 56, 0.7)), 
          url(${BackgroundImages.loginBgFika}) no-repeat center center fixed`,
          backgroundSize: 'cover',
        }}
        leftColumn={
          <img
            src={Logos.landingPageLoginBanner}
            style={{
              width: '100%',
              maxWidth: '670px',
              display: 'block',
              margin: '0 auto',
            }}
          />
        }
        rightColumn={
          <React.Fragment>
            <Form.Item>
              <Radio.Group
                size='large'
                onChange={(e) => setShowDashboardLogin(e.target.value === 'dashboard')}
                defaultValue='dashboard'
                style={{ display: 'flex' }}
              >
                <Radio.Button value='dashboard' style={{ flex: 1, textAlign: 'center' }}>
                  <Icon style={{ marginRight: '0.5rem' }} type='dashboard' /> Dashboard
                </Radio.Button>
                <Radio.Button value='pos' style={{ flex: 1, textAlign: 'center' }}>
                  POS
                  <Icon style={{ marginLeft: '0.5rem' }} type='shopping' />
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
            <div style={{ position: 'relative' }}>
              {transitions.map(({ item, key, props }) =>
                item ? (
                  <animated.div key={key} style={{ ...props, width: '100%' }}>
                    <WrappedLoginFormDashboard />
                  </animated.div>
                ) : (
                  <animated.div key={key} style={{ ...props, width: '100%' }}>
                    <WrappedLoginFormPOS />
                  </animated.div>
                ),
              )}
            </div>
          </React.Fragment>
        }
      />
    </>
  )
}
